import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/header/Header';
import LandingPage from './components/LandingPage';
import Page404 from './components/Page404';
import ThankYouPage from './components/steps/ThankYouPage';
import MatchPage from './components/steps/matching/MatchPage';
import MessagePage from './components/steps/message/MessagePage';
import { useEffect } from 'react';
import * as analytics from './services/analytics';

function App() {
    const location = useLocation();
    const isHomePage = !location.pathname.split('/')[0];
    const isMatchPage = location.pathname === 'match';
    const classSuffix = isHomePage || isMatchPage ? '--full' : '';

    useEffect(() => {
        analytics.pageView(location.pathname, window.location.href);
    }, [location]);

    return (
        <div>
            <Header />
            <div className="app__main-section__container">
                <section className={`app__main-section${classSuffix}`}>
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="finish" element={<ThankYouPage />} />
                        <Route path="match" element={<MatchPage />} />
                        <Route path="message" element={<MessagePage />} />
                        <Route path="*" element={<Page404 />} />
                        <Route path="404" element={<Page404 />} />
                    </Routes>
                </section>
            </div>
        </div>
    );
}

export default App;
